/** @format */

export const FILL = '#3E455A';
export const STROKE = '#46598C';
export const STROKE_WIDTH = 2;

export const BRUSH_STROKE = '#8884d8';

export const GRID_STROKE = '#4D4D4D';

export const STROKE_COLOR_NEW = '#6288EF';
